import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const getAllContracts = async () => {
    try {
        const response = await axios.get(`${API_URL}/contracts/getcontracts`);
        return response.data;
    } catch (error) {
        console.error("Error fetching contracts:", error);
        return [];
    }
};

export const getActiveContracts = async () => {
    try {
        const response = await axios.get(`${API_URL}/contracts/getactivecontract`);
        return response.data;
    } catch (error) {
        console.error("Error fetching contracts:", error);
        return [];
    }
};

export const AddNewContract = async (contractData) => {
    try {
        const response = await axios.post(`${API_URL}/contracts/addcontract`, contractData);
        return response.data;
    } catch (error) {
        console.error("Error adding contract:", error);
        throw error;
    }
};

export const updateContract = async (contractData) => {
    try {
        const response = await axios.post(`${API_URL}/contracts/updatecontract`, contractData);
        return response.data;
    } catch (error) {
        console.error("Error updating contract:", error);
        throw error;
    }
};

